@let estado = estadoProductoMesa();

<div
  class="relative flex h-full flex-col overflow-hidden rounded-lg border-t-4 bg-white shadow-md transition-all duration-150 hover:shadow-lg active:scale-[0.995]"
  [class.border-yellow-200]="estado === EComandaMesaEstado.OCUPADA"
  [class.border-blue-200]="estado === EComandaMesaEstado.RESERVADA"
  [class.border-green-200]="estado === EComandaMesaEstado.LIBRE"
  [class.cursor-move]="modoEdicion()"
>
  <!-- BOTONES MODO EDICIÓN -->
  @if (modoEdicion()) {
    <div class="absolute end-0 top-0 z-10 flex overflow-hidden rounded-bl-lg shadow-sm">
      <button
        class="bg-white/90 px-3 py-1.5 text-xs font-medium text-slate-500 transition-all duration-150 hover:bg-accent-600 hover:text-white"
        title="Editar mesa"
        type="button"
        (click)="$event.stopPropagation(); editar.emit(mesa())"
      >
        <i class="bi bi-pencil" aria-hidden="true"></i>
      </button>

      <div
        class="flex cursor-move touch-none select-none items-center gap-1 bg-accent-600 px-3 py-1.5 text-xs font-bold text-white"
      >
        <i class="bi bi-grip-vertical text-sm" aria-hidden="true"></i>
        <span>Mover</span>
      </div>
    </div>
  }

  <!-- CONTENIDO -->
  <div
    class="flex min-h-0 flex-1 flex-col gap-3 p-4"
    [class.pt-11]="modoEdicion()"
  >
    <!-- HEADER -->
    <div class="flex shrink-0 items-start justify-between gap-2">
      <div class="min-w-0">
        <h3 class="truncate text-base font-bold text-slate-900 sm:text-lg">
          {{ mesa().nombre }}
        </h3>

        <p class="truncate text-xs text-slate-600 sm:text-sm">
          {{ subtituloMesa() }}
        </p>
      </div>

      @switch (estado) {
        @case (EComandaMesaEstado.RESERVADA) {
          <span
            class="shrink-0 whitespace-nowrap rounded bg-blue-100 px-2 py-1 text-xs text-blue-800"
          >
            Reservada
          </span>
        }
        @case (EComandaMesaEstado.LIBRE) {
          <span
            class="shrink-0 whitespace-nowrap rounded bg-green-100 px-2 py-1 text-xs text-green-800"
          >
            Libre
          </span>
        }
        @case (EComandaMesaEstado.OCUPADA) {
          <span
            class="shrink-0 whitespace-nowrap rounded bg-yellow-100 px-2 py-1 text-xs text-yellow-800"
          >
            Ocupada
          </span>
        }
      }
    </div>

    <!-- BODY -->
    <div class="min-h-0 flex-1 space-y-2 text-sm text-slate-700">
      @if (mesa().estado === EComandaMesaEstado.LIBRE) {
        <p class="text-slate-500">Sin comanda activa</p>
      } @else {
        <div class="flex justify-between gap-2">
          <span class="text-slate-500">Hora:</span>
          <span class="font-semibold text-slate-900">{{ horaApertura() }}</span>
        </div>

        <div class="flex justify-between gap-2">
          <span class="text-slate-500">Productos:</span>
          <span class="font-semibold text-slate-900">
            {{ mesa().comanda?.productos?.length || 0 }}
          </span>
        </div>

        <div class="flex justify-between gap-2">
          <span class="text-slate-500">Total:</span>
          <span class="truncate font-semibold text-slate-900">
            {{ calcularTotal() | currency: 'PEN' : 'S/. ' }}
          </span>
        </div>
      }
    </div>
  </div>
</div>
